import { NavLink } from "react-router-dom";
import { Home, History, Settings } from "lucide-react";

const tabs = [
  { to: "/app", label: "Home", icon: Home, testId: "tab-home", end: true },
  { to: "/app/history", label: "History", icon: History, testId: "tab-history" },
  { to: "/app/settings", label: "Settings", icon: Settings, testId: "tab-settings" },
];

export default function BottomTabs() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-[#E5E7EB] shadow-[0_-2px_12px_rgba(0,0,0,0.04)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-tabs"
    >
      <div className="max-w-lg mx-auto grid grid-cols-3">
        {tabs.map(({ to, label, icon: Icon, testId, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testId}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center py-2.5 gap-0.5 transition-colors ${
                isActive ? "text-[#2F5BFF]" : "text-[#6B7280] hover:text-[#1F3A5F]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={22} strokeWidth={isActive ? 2.4 : 1.8} />
                <span className={`text-[11px] ${isActive ? "font-semibold" : "font-medium"}`}>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
